// src/containers/layout/oura-business-shell.tsx
//
// The chrome for ONE business, opened in its own browser tab.
//
// A business is a workspace, not a page. Staff open one, work it for an hour,
// and keep two or three clients open side by side. So the Businesses list opens
// each one in a new tab, and inside that tab the platform sidebar goes away:
// the business sidebar (BusinessDetail) is the only nav, and the whole width is
// the work.
//
// This is deliberately the rail swap gameplan A3 removed, reversed on purpose
// (YW, 11 Sep 2026). What A3 removed was a rail carrying ONE item, which hid
// every other product and gave nothing back. This carries nine sections and a
// route home, and it only ever applies to a tab you opened for that business:
// the list, the roll-up and every other product keep the platform sidebar.

import type { ReactNode } from "react";
import { SnackbarProvider } from "@hook/use-snackbar";
import MaintenanceBanner from "@container/maintenance-banner";
import { PAGE_GROUND } from "@oura/ui";

export default function OuraBusinessShell({ children }: { children: ReactNode }) {
    return (
        <SnackbarProvider>
            {/* No padding and no max-width container: the business sidebar is
                flush to the window edge and full height, and the chrome sets
                the content column's own width. The page ground shows behind
                everything that is not the sidebar. The maintenance banner sits
                across the top and scrolls away; the sidebar is sticky, so it
                stays put (#3561). Admins see it here too. */}
            <div className={`min-h-screen ${PAGE_GROUND}`}>
                <MaintenanceBanner showToAdmins />
                {children}
            </div>
        </SnackbarProvider>
    );
}
